import React, { useEffect, useState } from "react";
import {
  View,
  Tabs,
  Button,
  Icon
} from "@aws-amplify/ui-react";
import "./Task.css";
import TaskList from "./TaskList";
import { MdRefresh } from "react-icons/md";
import emitter from '../../eventBus/EventBus';


const Task = () => {
  // State to manage reload key for TaskList components
  const [reloadKey, setReloadKey] = useState(0);

  // Function to force reload
  const forceReload = () => {
    setReloadKey((prevKey) => prevKey + 1);
  };

  // Use effect to listen to the forceReload event
  useEffect(() => {
    emitter.on('createdNewTask', forceReload);

    // Cleanup function to remove the listener
    return () => {
      emitter.off('createdNewTask', forceReload);
    };
  }, []);

  return (
    <View maxWidth="100%" padding="0rem" minHeight="100vh">
      <View
        backgroundColor="var(--amplify-colors-white)"
        borderRadius="6px"
        maxWidth="100%"
        padding="1rem"
        marginBottom="20px"
      >
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          <h2>I tuoi task</h2>
          <h2 style={{cursor: 'pointer'}}><Icon marginLeft="5px" as={MdRefresh} onClick={forceReload}/></h2>
        </div>
      <Tabs.Container isLazy={true} defaultValue="1">
        <Tabs.List>
          <Tabs.Item value="1">Da completare</Tabs.Item>
          <Tabs.Item value="2">Completati</Tabs.Item>
        </Tabs.List>
      <Tabs.Panel value="1">
        <TaskList key={`dacompletare-${reloadKey}`} completato={false}></TaskList>
      </Tabs.Panel>
      <Tabs.Panel value="2">
        <TaskList key={`completati-${reloadKey}`} completato={true}></TaskList>
      </Tabs.Panel>
      </Tabs.Container>
    </View>
  </View>
  );
};

export default Task;
